import styled from 'styled-components';

export const StoreLink = styled.a`
  color: ${p => p.theme.text.linkExternal};

  &:hover {
    color: ${p => p.theme.text.callToActionHover};
    text-decoration: underline;
  }
`;
